/**
 * 批量文书上传弹框控制器
 * Created by RoryHe on 2020/6/18.
 */
import Vue from 'vue';
import batchUploadDialog from './batch-upload-dialog.vue';

const batchUploadDialogConstructor = Vue.extend(batchUploadDialog);
const instance = new batchUploadDialogConstructor({el: document.createElement('div')});


const newLoading = {
  show(op) {
    instance.visible = true;
    instance.queryParams = op.params;
    instance.handlerFunc = op.handlerFunc;
    document.body.appendChild(instance.$el);
    document.body.style.overflow = 'hidden';
  },
  isShow() {
    return instance.visible;
  },
  hide(op) {
    instance.visible = false;
    document.body.style.overflow = '';
  },
};

const install = function () {
  if (!Vue.$batchUploadDialog) {
    Vue.$batchUploadDialog = newLoading;
  }
  Vue.mixin({
    created() {
      this.$batchUploadDialog = Vue.$batchUploadDialog;
    }
  });
};

export default install;
